import { gql } from '@apollo/client';

export default gql`
  mutation DeleteThreadAnswer(
    $courseId: String!
    $threadId: String!
    $answerId: String!
  ) {
    deleteThreadAnswer(
      courseId: $courseId
      threadId: $threadId
      answerId: $answerId
    )
      @rest(
        type: "ThreadAnswer"
        path: "courses/{args.courseId}/threads/{args.threadId}/answers/{args.answerId}"
        method: "DELETE"
      ) {
      _id
    }
  }
`;
